<template>
  <div>
    <div :id="id" :style="{height: '280px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => '1'
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // goneType: []
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.$nextTick(() => {
          this.drawLine(newValue)
        })
      },
      immediate: true,
    }
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // // 获取哪一项不存在
      //  myChart.on("legendselectchanged", (paramas) => {
      //   if (!this.goneType.includes(paramas.name)) {
      //     this.goneType.push(paramas.name)
      //   } else {
      //     this.goneType = this.goneType.filter(item => item !== paramas.name )
      //   }
      // })
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderWidth:'1',
          borderColor:'gray',
          axisPointer: {
            type: 'shadow'
          },
          textStyle:{
            color:'black',
          },
          formatter:(params) => {
            let back = null
            switch (this.type) {
              case '1':
                back = '<span style="font-size: 14px;">' + params.name + params.percent + '%' +'</span>' + "<br/>" + params.name + "券金额" + ':' + params.data.value + "元" + "<br/>" + params.name + "券张数" + ':' + params.data.couCnt + "张"
                break
              case '2':
                back = '<span style="font-size: 14px;">' + params.name + params.percent + '%' +'</span>' + "<br/>" + params.name + "券金额" + ':' + params.data.amount + "元" + "<br/>" + params.name + "券张数" + ':' + params.data.value + "张"
                break
            }
            return back
          },
        },
        legend: {
          bottom: -5,
          left: 'center'
        },
        color : [ '#3377FF', '#FFAC52', '#ADCD40' ],
        series: [{
          type: 'pie',
          radius: ['55%', '66%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }]
      }, true)
    }
  }
}
</script>
<style scoped lang="less">

</style>